// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7vfDJ","colBig":"styles_colBig__1eYV_","colSmall":"styles_colSmall__1BXxW"};